import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import {
  AppConfig,
  UserSessionSettings,
  SystemDateTimeInfo,
} from '../components/settings/settings';
import { ISystemSettings, SystemSettingsRow } from '../interfaces/system-settings';
import { MixpanelSettingsDTO } from '../components/mixpanel/mixpanel-settings';
import { DialpadSettingsDTO } from '../components/dialpad/dialpad-settings';

@Injectable({ providedIn: 'root' })
export class SettingsService {
  public url = '/api/settings';

  private settingsPromise: Promise<ISystemSettings>;
  private settingsListPromise: Promise<SystemSettingsRow[]>;

  public travelSchedulerEnabled: boolean = false;

  constructor(public http: HttpClient) {
    this.settingsListPromise = http
      .get<SystemSettingsRow[]>(`${this.url}/systemsettingslist`)
      .toPromise();
    this.settingsPromise = http.get<ISystemSettings>(`${this.url}/systemsettings`).toPromise();
    this.settingsPromise.then((s) => {
      this.travelSchedulerEnabled = s.travelSchedulerEnabled;
    });
  }

  public GetSystemSettings(): Promise<ISystemSettings> {
    return this.settingsPromise;
  }

  public GetInvoiceProcessPassPhrase(processId): Promise<any> {
    return this.http.get(`${this.url}/invoicerunpassphrase?processId=${processId}`).toPromise();
  }

  public GetSettingsList(): Promise<SystemSettingsRow[]> {
    return this.settingsListPromise;
  }

  public save(item): Promise<any> {
    return this.http
      .post(`${this.url}/save`, item)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  public getUserSessionSettings(): Promise<UserSessionSettings> {
    return this.http.get<any>(`${this.url}/usersessionsettings`).toPromise();
  }

  public getMixpanelSettings(): Promise<MixpanelSettingsDTO> {
    return this.http.get<any>(`${this.url}/mixpanel-settings`).toPromise();
  }

  public getCurrentSystemDateTimeInfo(): Promise<SystemDateTimeInfo> {
    return this.http.get<any>(`${this.url}/systemDateTimeInfo`).toPromise();
  }

  public GetDialpadLivechatSettings(): Promise<DialpadSettingsDTO> {
    return this.http.get<any>(`${this.url}/dialpad-livechat-settings`).toPromise();
  }

  extractData(res: any) {
    return res;
  }

  public removeRevolutAccessKeys(): Promise<any[]> {
    return this.http
      .get<any[]>(`${this.url}/remove-revolut-access-keys`)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  private handleError(errorResponse: HttpErrorResponse | any) {
    let fullErrorMessage: string;
    if (errorResponse instanceof HttpErrorResponse) {
      const error = errorResponse.error || JSON.stringify(errorResponse);
      fullErrorMessage = `${errorResponse.status} - ${errorResponse.statusText || ''} ${error}`;
    } else {
      fullErrorMessage = errorResponse.message ? errorResponse.message : errorResponse.toString();
    }
    console.error(fullErrorMessage);
    return Promise.reject(fullErrorMessage);
  }

  getTurnstileSiteKey(): Promise<string> {
    return this.http.get<string>(`${this.url}/turnstile-site-key`).toPromise();
  }
}
